import { CircleCheck, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

/**
 * ConfirmButton - Quick-confirm action button for unconfirmed timeline rows
 *
 * Features:
 * - Ghost variant for subtle, professional appearance
 * - Green accent on hover for positive action feedback
 * - Loading state with spinner
 * - Disabled state with reduced opacity
 * - Fully accessible with ARIA attributes
 *
 * @param {Object} props
 * @param {Function} props.onClick - Handler for confirm action
 * @param {boolean} props.loading - Shows loading spinner when true
 * @param {boolean} props.disabled - Disables button when true
 * @param {string} props.className - Additional CSS classes
 */
export default function ConfirmButton({
  onClick,
  loading = false,
  disabled = false,
  className
}) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      disabled={disabled || loading}
      aria-label="Confirm order"
      aria-busy={loading}
      className={cn(
        // Hover effect: green tint on icon and subtle background
        'hover:bg-green-50 hover:text-green-600',
        // Disabled state handled by button-variants (opacity-50)
        className
      )}
    >
      {loading ? (
        <Loader2 className="h-5 w-5 animate-spin" />
      ) : (
        <CircleCheck className="h-5 w-5" />
      )}
    </Button>
  )
}
